module.exports = __webpack_public_path__ + "static/media/Sprchovy_olej_s_CBD_retina.1466a213.jpg";